import { FC, useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import homeState from '../../../atoms/home';
import { UserDetail } from '../../../connector/type';
import './PlainMessage.scoped.scss'

interface PlainMessageProps {
  userId: string;
  userDetail: UserDetail | undefined;
  contents: string;
}

const PlainMessage: FC<PlainMessageProps> = ({ userId, userDetail, contents }) => {
  const [home] = useRecoilState(homeState);

  const [isDisplayRealIcon, setIsDisplayRealIcon] = useState(true);

  useEffect(() => {
    if (userDetail?.gasMask) {
      setIsDisplayRealIcon(false);
    }
  }, []);

  const levelIconMouseEnterEvent = () => {
    if (userDetail?.gasMask) {
      setIsDisplayRealIcon(true);
    }
  };

  const levelIconMouseLeaveEvent = () => {
    if (userDetail?.gasMask) {
      setIsDisplayRealIcon(false);
    }
  };

  return (
    <div className="chatting-plain-message">
        <i className="chatting-plain-message__level-icon">
        { userId === 'admin'
        ?
          <img 
            src={'/img/level/kscore/admin.gif'}
            width="23"
            height="23" 
            alt="User level icon"
          /> :<img 
            src={`/img/level/kscore/${userDetail?.level ?? '1'}.gif`}
            width="23"
            height="23" 
            alt="User level icon"
          />
        }
        </i> 
        <span className="chatting-plain-message__nickname">
          <button style={{ fontSize: home.fontSize }} className="chatting-plain-message__nickcolor">
            {
              userDetail?.familyNickname
                ? (
                  <span style={{ color: '#d95904' }}>
                    {userDetail?.familyNickname}
                  </span>
                )
                : null
            }
            {userDetail?.nickname ?? userId}
          </button>
        </span>
        <span className="chatting-plain-message__contents">
          {
            userId === 'admin'
              ? (
                <b style={{ color: '#ffa500' }}>
                  {contents}
                </b>
              )
              : contents
          }
        </span>
    </div>
  );
}

export default PlainMessage;